import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetAttendance = async (params: {
  date: string;
  search?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/attendance`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load attendance.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const SaveAttendance = async (payload: {
  date: string;
  records: Array<{
    employee_id: string;
    status: string;
    check_in?: string | null;
    check_out?: string | null;
    notes?: string | null;
  }>;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/attendance/save`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save attendance.",
      errors: error?.response?.data?.errors,
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const QuickClockAttendance = async (payload: {
  identifier: string;
  date?: string;
  time?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/attendance/quick-clock`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to process check-in/out.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const GetMonthlyAttendanceSheet = async (params: {
  month: string;
  search?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/attendance/sheet`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load monthly attendance sheet.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetEmployeeMonthlyLogs = async (params: {
  employee_id: string;
  month: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/attendance/employee-sheet`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load employee monthly logs.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
